<template>
    <div>
        <!--UPLOAD-->
        <div v-if="isInitial || isSaving">
            <div class="dropbox">
                <input type="file" :multiple="multiple" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                       accept="image/png,image/jpeg,image/jpg" class="input-file">
                <p v-if="isInitial">
                    Sleep een foto hier <br>of klik om een foto te selecteren<br>
                    (jpg of png, max. 4MB)
                </p>
                <p v-if="isSaving">
                    {{ fileCount }} foto<span v-if="fileCount > 1">'s</span> aan het versturen ...
                </p>
            </div>
        </div>
        <!--SUCCESS-->
        <div v-if="isSuccess">
            <ul class="list-unstyled">
                <li v-for="item in uploadedFiles">
                    <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
                </li>
            </ul>
            <p>
                {{ uploadedFiles.length }} foto<span v-if="fileCount > 1">'s</span> toegevoegd.<br><a class="link" href="javascript:void(0)" @click="reset()">Klik hier om opnieuw te starten.</a>
            </p>
        </div>
        <!--FAILED-->
        <div v-if="isFailed">
            <p class="error">
                Fout: {{ uploadError }} <br><a class="link" href="javascript:void(0)" @click="reset()">Klik hier om opnieuw te starten.</a>
            </p>
        </div>
    </div>
</template>

<script>
// swap as you need
// import { upload } from '../../js/file-upload.fake.service'; // fake service
// import { upload } from '../../js/file-upload.service';
import * as axios from "axios";   // real service

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
    props: {
        folderId: Number,
        fieldId: Number,
        elementId: Number,
        originalName: String,
        url: String
    },
    data() {
        return {
            multiple: false,
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'assets-upload',
            fileCount: 0
        }
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        }
    },
    methods: {
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;

            this.$emit('uploadComplete', {
                assetId: null
            })
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            const action = '/actions/reveil-module/assets/upload'
            window.axios({
                method: 'post',
                headers: {
                    "Content-Type": 'application/x-www-form-urlencoded',
                },
                data: formData,
                url: action
            }).then((response) => {
                console.log(response)
                if(response.data && response.data.assetId !== undefined && response.data.assetId !== null) {
                    this.$emit('uploadComplete', {
                        assetId: response.data.assetId
                    })
                    this.uploadedFiles = [].concat({
                        'originalName': response.data.filename,
                        'url': response.data.url
                    });
                    this.currentStatus = STATUS_SUCCESS;
                }else{
                    this.uploadError = 'an error occured'
                    this.currentStatus = STATUS_FAILED
                }
            }).catch((error) => {
                console.log(error)
                this.uploadError = error
                this.currentStatus = STATUS_FAILED
            })
        },
        filesChange(fieldName, fileList) {

            var allowed = ['image/png','image/jpeg','image/jpg']

            if (!fileList.length) return

            for (var file of fileList) {
                if(allowed.includes(file.type) === false) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = file.name + ' is geen geldige foto.'
                    return
                }
                if(file.size > 5242880) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = file.name + ' is groter dan 4MB.'
                    return
                }
            }

            const formData = new FormData()

            var csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
            formData.set('CRAFT_CSRF_TOKEN', csrfToken)
            formData.set('folderId', this.folderId)
            formData.set('fieldId', this.fieldId)
            formData.set('elementId', this.elementId)

            // append the files to FormData
            Array
                .from(Array(fileList.length).keys())
                .map(x => {
                    formData.append(fieldName, fileList[x], fileList[x].name);
                });

            // save it
            this.save(formData);

            this.$emit('uploadComplete', {
                formData: formData,
                fileList: fileList
            });
        }
    },
    mounted() {
    },
    created() {
        if(this.originalName !== undefined && this.url !== undefined && this.originalName != '' && this.url != '' && this.originalName !== null && this.url !== null) {
            this.uploadedFiles = [].concat({
                'originalName': this.originalName,
                'url': this.url
            });
            this.currentStatus = 2;
            this.fileCount = 1;
        }else{
            this.reset();
        }
    }
}

</script>

<style>
.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 120px; /* minimum height */
    position: relative;
    cursor: pointer;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 120px;
    position: absolute;
    cursor: pointer;
}

.dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
    text-align: center;
    padding: 20px 0;
}

a.link {
    display: block;
    text-decoration: underline;
}
a.link:hover {
    text-decoration: none;
}

p.error {
    color: #D94862;
}
</style>